<template>
  <div class="v-input-wrapper">
    <label class="v-input__label" :class="{ 'v-input__label--invalidd': invalid }">{{ label }}</label>
    <div class="v-input" :class="[classes, { 'v-input--has-value': hasValue, 'v-input--focused': isFocused }]">
      <input
        class="v-input__field"
        v-bind="$attrs"
        :type="type"
        v-focus="focus"
        :min="min"
        :max="max"
        :step="step"
        :value="value"
        :disabled="disabled"
        :pattern="pattern"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      />
      <div class="v-input__bar"></div>
    </div>
    <div class="v-input__hint-wrapper">
      <div class="v-input__hint" v-if="hint">{{ hint }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VInputR',

  inheritAttrs: false,

  props: {
    label: String,
    value: [String, Number],
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    min: {
      type: [String, Number],
      default: null
    },
    max: {
      type: [String, Number],
      default: null
    },
    pattern: {
      type: [String],
      default: null
    },
    float: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    invalid: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    isVisiblePopover: Boolean,
    focus: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isFocused: false
    }
  },

  computed: {
    classes () {
      return {
        'v-input--invalid': this.invalid
      }
    },
    step () {
      return this.float ? `0.${'0'.repeat(this.precision - 1)}1` : '1'
    },
    minValue () {
      return this.min !== null ? Number(this.min) : null
    },
    maxValue () {
      return this.max !== null ? Number(this.max) : null
    },
    hasValue () {
      return this.value !== null && this.value !== '' && this.value !== undefined
    }
  },

  methods: {
    onInput (e) {
      let value = e.target.value

      if (this.float) {
        value = value.replace(/^(\d*[.,]?\d{0,2}).*$/, '$1')

        if (value !== '') {
          const integerPart = parseInt(value.split(/[,.]/)[0])

          if (this.maxValue !== null && integerPart >= this.maxValue) {
            value = this.maxValue.toString()
          } else if (value.includes('.') || value.includes(',')) {
            const parts = value.split(/[,.]/)
            if (parts[1] && this.precision) {
              parts[1] = parts[1].slice(0, this.precision)
              value = parts.join(value.includes('.') ? '.' : ',')
            }

            const numValue = parseFloat(value.replace(',', '.'))
            if (!isNaN(numValue) && this.maxValue !== null && numValue >= this.maxValue) {
              value = this.maxValue.toString()
            }
          }
        }
      }

      e.target.value = value
      this.$emit('input', value)
    },

    onFocus () {
      this.isFocused = true
    },

    onBlur () {
      this.isFocused = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-input-wrapper {
  padding-top: 0;
  margin-bottom: 0.2rem;
}

.v-input {
  position: relative;

  &__field {
    width: 100%;
    font-size: 1.5rem;
    padding: 1rem;
    height: 4rem;
    display: block;
    font-weight: 900;
    border: .2rem solid transparent;
    border-radius: 1rem;
    background: #EEEEEE;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:focus {
      outline: none;
    }

    &:focus ~ .v-input__bar:before,
    &:focus ~ .v-input__bar:after {
      width: 50%;
    }
  }

  &__hint-wrapper {
    min-height: 1.5rem;
  }

  &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
    position: relative;
    bottom: -2px;
  }

  &--invalid {
    .v-input__field {
      background: #fff5f5;
    }
  }

  &--has-value {
    .v-input__field {
      background-color: #F4F4F4;
    }
  }

  &--focused {
    .v-input__field {
      background-color: #DDF2E3;
    }
  }
}

.v-input__label {
  display: block;
  color: $color-gray;
  font-size: 1.3rem;
  margin-bottom: .5rem;
  pointer-events: none;
  line-height: 1.3rem;

  &--invalid {
    color: $color-red !important;
  }
}
</style>